import { AxiosError } from 'axios';
import { createAsyncThunk } from '@reduxjs/toolkit';

import { axiosWithConfig } from 'api';
import { UserManagementBaseResponse } from 'api/interfaces';
import showToast from 'utils/showToast';

export const checkUserComboId = createAsyncThunk<
  { data: { endusers: { id: string }[] } },
  { userData: Record<string, string> }
>('company/checkUserComboId', async ({ userData }, { rejectWithValue }) => {
  const endpoint = `${process.env.REACT_APP_HRIS_ENDPOINT}graphql`;

  const body = {
    query: `query PreloadEndUsers {
          endusers(
            ${Object.keys(userData)
              .reduce((acc: string[], key) => {
                acc.push(`${key}: "${userData[key]}"`);
                return acc;
              }, [])
              .join(' ')}
          ) {
              id
          }
      }`,
  };

  const axios = await axiosWithConfig({ withAuthentication: false });

  try {
    const { data } = await axios.post(endpoint, body);

    if (data.errors) {
      throw new Error(data.errors[0].message);
    }

    return { data: data.data };
  } catch (e) {
    const error: AxiosError<UserManagementBaseResponse> =
      e as AxiosError<UserManagementBaseResponse>;

    showToast('error', error.message);

    return rejectWithValue(error.response?.data || error.message);
  }
});
